import React from 'react';
import cn from 'classnames';
import { string, node } from 'prop-types';

const propTypes = {
  children: node.isRequired,
  className: string,
};

const CustomTableRow = ({ className, children, ...rest }) => (
  <div className={cn('table-row', className)} {...rest} role="row">
    {children}
  </div>
);

CustomTableRow.propTypes = propTypes;

export default CustomTableRow;
